import ActivityTransactionsTable from 'payments/components/ActivityTransactionsTable.jsx';
import { Container } from 'flux/utils';
import { makeCancelable } from 'lib/promise';
import React, { Component } from 'react';
import TransactionActions from 'payments/actions/TransactionActions';
import TransactionsListNuxSection from 'payments/components/TransactionsListNuxSection.jsx';
import TransactionStore from 'payments/stores/TransactionStore';
import WalletTabLoader from 'payments/components/WalletTabLoader.jsx';

class TransactionsListContainer extends Component {
  static getStores() {
    return [TransactionStore];
  }

  static calculateState(state) {
    return {
      errored: state ? state.errored : false,
      loading: state ? state.loading : true,
      transactions: TransactionStore.getTransactions(),
    };
  }

  componentDidMount() {
    const onError = (reason) => {
      if (reason && reason.isCanceled) {
        return;
      }

      this.setState({ errored: true });
      throw reason;
    };

    const promise = TransactionActions.loadTransactions();
    this.cancelable = makeCancelable(promise);
    this.cancelable.promise.then(() => this.setState({ loading: false })).catch(onError);
  }

  componentWillUnmount() {
    this.cancelable.cancel();
  }

  render() {
    if (this.state.errored) {
      return <span>An error happened</span>;
    }

    if (this.state.loading && this.state.transactions.length === 0) {
      return <WalletTabLoader />;
    }

    if (this.state.transactions.length === 0) {
      return <TransactionsListNuxSection />;
    }

    return <ActivityTransactionsTable transactions={this.state.transactions} />;
  }
}

export default Container.create(TransactionsListContainer);



// WEBPACK FOOTER //
// ./src/payments/containers/TransactionsListContainer.jsx